import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowsDiagonalInOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15 1.99 11.528 5.46h2.977v1.4H9.138V1.495h1.4V4.47L14.01 1zM1.495 9.138h5.367v5.367h-1.4v-2.977L1.99 15 1 14.01l3.472-3.472H1.495z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ArrowsDiagonalInOutlinedSize16Glyph.displayName = 'ArrowsDiagonalInOutlinedSize16Glyph';
